<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="frontmatter-rw Dedication-rw auto-rw page-open-left-rw" epub:type="frontmatter dedication" id="dedication">
<p class="dedication"><em>Dedicated to the memory of</em></p>
<p class="dedication1"><em>John F. Marks, 1936–2017</em></p>
<p class="dedication1"><em>Friend and sensei</em></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?6469eee4